import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Servers from '../views/Servers.vue'
import Login from '../views/Login.vue'
import store from '../store'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true}
  },
  {
    path: '/servers',
    name: 'servers',
    component: Servers,
    meta: { requiresAuth: true}
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false}
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})


let entryUrl = null;

//const guardAuth = async (to, from, next) => {
router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login') {
    if (store.state.auth.loggedIn) {
      if (entryUrl) {
        const url = entryUrl;
        entryUrl = null;
        return next(url); // goto stored url
      } else {
        return next(); // all is fine
      }
    }

    console.log('store.state.auth.loggedIn: ',store.state.auth.loggedIn)

    await store.dispatch('auth/checkAuth'); 
    // we use await as this async request has to finish 
    // before we can be sure

    if (store.state.auth.loggedIn) {
      next();
    } else {
      entryUrl = to.path; // store entry url before redirect
      next('/login');
    }
    //next('/login');
  } else {
    next();
  }
  
  //next()
});

//router.beforeEach = guardAuth;


export default router
